import React, { useState, useEffect } from 'react';
import TableComponent from '../../../atoms/TableComponent/DataTable';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Tooltip,FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { usePermissions } from '../../../GlobalFunction/userPermissions';
import axiosInstance from '../../../lib/axios';
import AddIcon from '@mui/icons-material/Add';
import PropertyFilter from '../../PropertyFilter';
import { useSelector, useDispatch } from 'react-redux';
import { 
  selectProperties, 
  selectGlobalProperty,
  selectLocalProperty,
  setLocalProperty,
  fetchProperties
} from '../../../redux/propertySlice';

const columns = [
  { id: 'RowNum', label: 'SrNo', minWidth: 10 },
  { id:'PropName', label:'Property',minWidth:40},
  { id: 'IsuNo', label: 'IsuNo', minWidth: 10 },
  { id: 'IsuDt', label: 'IsuDate', minWidth: 10 },
  { id: 'PartyName', label: 'SupplierFrom', minWidth: 10 },
  { id: 'PartyDtlName', label: 'SupplierTo', minWidth: 10 },
  { id: 'ShPartyName', label: 'ActSupplierFrom', minWidth: 10 },
  { id: 'ShPartyDtlName', label: 'ActSupplierTo', minWidth: 10 },
  { id: 'RefNo', label: 'RefNo', minWidth: 10 },
  { id: 'BillNo', label: 'BillNo', minWidth: 10 },
  { id: 'BillDate', label: 'BillDate', minWidth: 10 },
  { id: 'IsuQty', label: 'Qty', minWidth: 10 },
  { id: 'Amount', label: 'Amount', minWidth: 10 },
  { id: 'Remark', label: 'Remark', minWidth: 10 },
];

export default function StoreIssueTable() {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(15);
  const [searchTerms, setSearchTerms] = useState({});
  const [rows, setRows] = useState([]);

    const [SelectedProperty, setSelectedProperty] = useState(null);
    const UserId = sessionStorage.getItem('UserId');
  const navigate = useNavigate();
     const dispatch = useDispatch();
        const properties = useSelector(selectProperties);
        const globalProperty = useSelector(selectGlobalProperty);
        const localProperty = useSelector(state => selectLocalProperty(state, 'assettable'));
        const selectedProperty = localProperty || globalProperty;
      
        useEffect(() => {
          if (properties.length === 0) {
            dispatch(fetchProperties());
          }
        }, [dispatch, properties.length]);
      
        useEffect(() => {
          fetchStoreIsuData();
        }, [selectedProperty]);
      
        const handlePropertyChange = (event) => {
          const selectedId = event.target.value;
          dispatch(setLocalProperty({
            componentId: 'assettable',
            propertyId: selectedId
          }));
        };
  

  const permissions = usePermissions("Store Issue");
  const { AddRec = "0" } = permissions || {};

  const handlePermittedClick = () => {
    if (AddRec === "1") {
      handleClick();
    }
  };

  // useEffect(() => {
  //   fetchStoreIsuData();
  // }, []);

 
  const fetchStoreIsuData = async () => {
    try {
      const response = await axiosInstance.post(`TrnIsu/GetTrnIsuDashBoard`,
        {
          "start": 0,
          "PageSize": 0,
          "SearchText": ""
        },
      );
    

      if (response.data.Status === 0) {
        const data = response.data.Data || []; // Default to empty array if null
      
        setRows(data);
      } else {
        console.error('Error fetching company data:', response.data.message);
      }
    } catch (error) {
      console.error('Error fetching company data:', error);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleClick = () => {
    navigate('/storeissue-master');
  };

  const handleHomeClick = () => {
    navigate('/dashboard');
  };

  const handleSearchChange = (columnId, value) => {
    setSearchTerms(prev => ({ ...prev, [columnId]: value }));
    setPage(0);
  };

  const filteredRows = React.useMemo(() => {
    return rows.filter(row => {
      return Object.entries(searchTerms).every(([columnId, term]) => {

        if (!term) return true;
        const value = row[columnId];

        if (typeof value === 'string') {
          return value.toLowerCase().includes(term.toLowerCase());
        } else if (typeof value === 'number') {
          return value.toString().includes(term);
        }
        return true;
      });
    });
  }, [searchTerms, rows]);


const handleRowDoubleClick = (row) => {

  navigate('/storeissue-master', { 
    state: { 
      IsuId: row.IsuId, 
      mode: 'view',
      rowData: row 
    } 
  });
};


  const handleLocationclick = () => {
    navigate('/inventory')
  }

  const addButtonStyles = {
    background: AddRec === "1" ? "#635bff" : "rgba(0, 0, 0, 0.12)",
    color: AddRec === "1" ? "white" : "rgba(0, 0, 0, 0.26)",
    borderRadius: "50px",
    padding: "8px 20px",
    boxShadow: AddRec === "1" ? "0px 6px 15px rgba(0, 0, 0, 0.3)" : "none",
    transition: "background 0.3s ease",
    "&:hover": {
      background: AddRec === "1" ? "#524ccc" : "rgba(0, 0, 0, 0.12)"
    },
    "&:disabled": {
      backgroundColor: "rgba(0, 0, 0, 0.12)",
      color: "rgba(0, 0, 0, 0.26)"
    }
  };

   const PropertyFilterJSX = (
            <FormControl fullWidth size="small" sx={{ minWidth: 250 }}>
              <InputLabel id="property-select-label">Filter by Property</InputLabel>
              <Select
                labelId="property-select-label"
                id="property-select"
                value={selectedProperty || ''}
                onChange={handlePropertyChange}
                label="Filter by Property"
              >
                {properties.map((property) => (
                  <MenuItem key={property.Id} value={property.Id}>
                    {property.Name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          );

  const Filters = (
    <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
   {PropertyFilterJSX}
      <Tooltip
        title={AddRec !== "1" ? "You have no permission to add record" : ""}
        placement="top"
      >
        <span>
          <Button
            variant="contained"
            onClick={handlePermittedClick}
            size="small"
            disabled={AddRec !== "1"}
            sx={addButtonStyles}
          >
            <AddIcon />New
          </Button>
        </span>
      </Tooltip>
    </Box>
  );

  return (
    <TableComponent
      FiltersJsx={Filters}
      columns={columns}
      rows={rows}
      filteredRows={filteredRows}
      page={page}
      title="Store"
      titleMaster="Material Issue"
      rowsPerPage={rowsPerPage}
      handleRowDoubleClick={handleRowDoubleClick}
      handleSearchChange={handleSearchChange}
      handleChangePage={handleChangePage}
      handleChangeRowsPerPage={handleChangeRowsPerPage}
      handleClick={handleClick}
      handleHomeClick={handleHomeClick}
      handleLocationclick={handleLocationclick}
    />
  );
}